import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "../services/auth.service";

@Component({
  standalone: false,
  selector: "dua-redirect-page",
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: "./redirect-page.component.html",
})
export class RedirectPageComponent implements OnInit {
  constructor(private router: Router, private authService: AuthService) {}

  ngOnInit(): void {
    if (this.authService.getIsLoggedIn()) this.router.navigateByUrl("/dua");
  }
}
